define('StellarGrade.ST_NewsletterForm.NewsletterForm.View', [
    'stellargrade_st_newsletterform_newsletterform.tpl',
    'StellarGrade.ST_NewsletterForm.NewsletterForm.SS2Model',
    'Backbone',
    'jQuery',
], function (stellargrade_st_newsletterform_newsletterform_tpl, NewsletterFormSS2Model, Backbone, $) {
    'use strict';

    return Backbone.View.extend({
        template: stellargrade_st_newsletterform_newsletterform_tpl,

        initialize: function () {
            var self = this;
            var isNewsletterformEnabled = false;

            Backbone.history.on('route', function () {
                this.isNewsletterformEnabled = self.updateContentVisibility();
                self.render();
            });
            return { isNewsletterformEnabled: isNewsletterformEnabled };
        },
        events: { 'submit #newsletterForm': 'handleFormSubmit' },

        handleFormSubmit: function (e) {
            e.preventDefault();

            var self = this;
            var formData = {
                firstName: this.$('#newsletterform-firstName').val(),
                lastName: this.$('#newsletterform-lastName').val(),
                email: this.$('#newsletterform-email').val(),
                companyName: this.$('#newsletterform-companyName').val(),
                entityStatus: 38, // LEAD-Newsletter
                leadsource: 44277, // Website
                salesrep: 43, // House Acct
                custentity_cust_segmentation_pri: 13, // TBD
            };

            // SB
            // const URL =
            //     'https://439653-sb1.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1409&deploy=1&compid=439653_SB1&ns-at=AAEJ7tMQ0kCXO6YfH3IzLKpHc0UffzBFeKYjWUWVpbf-DQJ81xA';

            const URL = 'https://439653.extforms.netsuite.com/app/site/hosting/scriptlet.nl?script=1904&deploy=1&compid=439653&ns-at=AAEJ7tMQQ9Jn7brsg5ks0d22X7ukDWdgXzauQjFF2O16nfnmZ-o';

            $.ajax({
                url: URL,
                type: 'POST',
                data: JSON.stringify(formData),
                contentType: 'application/json',
                success: function (response) {
                    if (response.error) {
                        if (response.error.name === 'UNIQUE_CUST_ID_REQD') {
                            alert('Email already exists. Please try again with a different email address.');
                            return;
                        } else if (response.error === 'UNIQUE_EMAIL_NAME_REQD') {
                            alert('Email already exist link with another name!');
                            return;
                        }
                    } else {
                        alert(response.message);
                        window.location.href = '/';
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                },
            });
        },

        updateContentVisibility: function () {
            const currentUrl = window.location.pathname;
            const shoppingContentElement = $('.shopping-layout-content');

            if (currentUrl.includes('newsletter')) {
                shoppingContentElement.hide();
                return true;
            } else {
                shoppingContentElement.show();
                setTimeout(function () {
                    const firstInput = $('#newsletterform-firstName');
                    const formSection = $('#newsletterform-companyName');

                    if (firstInput) {
                        firstInput.focus();
                    }
                }, 100);
                return false;
            }
        },

        getContext: function getContext() {
            var isNewsletterformEnabled = window.location.href.includes('newsletter');

            $(document).ready(function () {
                const shoppingContentElement = $('.shopping-layout-content');
                const mainContentElement = $('.shopping-layout-main-container');

                if (isNewsletterformEnabled) {
                    if (shoppingContentElement.length > 0) {
                        shoppingContentElement.hide();
                        mainContentElement.css('min-height', '10px');
                    }
                } else {
                    shoppingContentElement.show();
                    mainContentElement.css('min-height', '20px');
                    isNewsletterformEnabled = false;
                }
            });

            return {
                isNewsletterformEnabled: isNewsletterformEnabled,
            };
        },
    });
});
